// extracted by mini-css-extract-plugin
export var columnList = "_fx-0";